import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { ContentRoute, Route } from '@caritas/ui';
import React, { PropsWithChildren } from 'react';

import {
  ContentPagePreviewQuery,
  useContentPagePreviewQuery,
} from '../../../generated/queries/preview';
import { mapContentPage } from '../../fragments/ContentPage.mappers';
import { useTranslations } from '../../fragments/Translations.mappers';
import { Page } from '../../utils/Page';
import { usePreviewParameters } from '../../utils/preview';

export default function ContentPagePreview() {
  const params = usePreviewParameters();
  const pageContext: SilverbackPageContext = {
    typeName: 'ContentPage',
    id: params.nid,
    remoteId: `${params.nid}:${params.lang}`,
    locale: params.lang,
    localizations: [],
  };

  const { data } = useContentPagePreviewQuery({
    id: params.nid,
    rid: params.rid,
  });

  const content = data?.loadContentPageRevision?.translations.filter(
    (trans) => trans.langcode === params.lang,
  )[0];

  const translations = useTranslations(pageContext);

  return content ? (
    <Page
      pageContext={pageContext}
      donationPurpose={content.donationPurpose}
      donationDescription={content.donationDescription}
      headerDisplayMode={content.header.displayMode}
      povertyPlatform={content.povertyPlatformParent}
    >
      <RouteComponent
        content={content}
        pageContext={pageContext}
        translations={translations}
      />
    </Page>
  ) : (
    <p>Loading preview</p>
  );
}

function RouteComponent({
  pageContext,
  content,
  translations,
}: PropsWithChildren<{
  pageContext: SilverbackPageContext;
  content: Exclude<
    ContentPagePreviewQuery['loadContentPageRevision'],
    undefined
  >['translations'][number];
  translations: ReturnType<typeof useTranslations>;
}>) {
  return (
    <Route
      definition={ContentRoute}
      input={mapContentPage(content, pageContext, '/__preview/page')}
      intl={translations}
    />
  );
}
